module.exports = __webpack_public_path__ + "img/136.f6bed5aa.jpg";